export class AdCreationError extends Error {
    constructor(message: string) {
        super(message);
    }
}
